// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { Chip, MenuItem } from '@mui/material';
import {
    TextSnippet as TextSnippetIcon,
    Comment as CommentIcon
} from '@mui/icons-material';
import i18n from '../../../i18n';
import DocumentsDialog from '../../dialogs/DocumentsDialog';
import CommentsDialog from '../../dialogs/CommentsDialog';
import Iconify from '../../../components/iconify';
import React from 'react';
import { reasonCodesConfig } from '../../../config/reasonCodes.config';
import ConfirmDialog from '../../dialogs/ConfirmDialog';
import { chargebackStatuses } from '../statuses';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class ChargebacksPage extends GridPageAbstract {
    chargebacksDocuments = [];
    chargebacksComments = [];

    constructor(props) {
        super(props);

        this.Name = 'publicChargebacks';
        this.Server = this.props.context.getState().server.publicChargebacks;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['reason', 'description', 'payment.uuid'];
        this.showTotalRow = true;
        this.exportButton = true;

        this.hasCustomLogicOnMount = true;

        const defaultHead = [
            {
                id: 'reason',
                label: 'reason',
                alignRight: false,
                cell: 'Text',
                displayGrid: true,
                displayAdd: true,
                disableEditor: true
            },
            {
                id: 'reasonCode',
                label: 'reasonCode',
                alignRight: false,
                cell: 'Entity',
                items: reasonCodesConfig,
                displayGrid: true,
                displayAdd: true,
                disableEditor: true
            },
            {
                id: 'description',
                label: 'description',
                alignRight: false,
                cell: 'Text',
                displayGrid: true,
                displayAdd: true,
                disableEditor: true
            },
            {
                id: 'externalCaseId',
                label: 'externalCaseId',
                alignRight: false,
                cell: 'Text',
                displayGrid: true,
            },
            {
                id: 'rrn',
                label: 'rrn',
                alignRight: false,
                cell: 'Text',
                displayGrid: true,
                displayAdd: true,
                disableEditor: true
            },
            {
                id: 'state',
                label: 'status',
                alignRight: false,
                cell: 'State',
                items: ['pending', 'accepted', 'rejected'],
                displayGrid: true,
                displayAdd: true,
                disableEditor: true
            },
            {
                id: 'commissions',
                label: 'commissions',
                alignRight: false,
                cell: 'CommissionsTotal',
                from: 'publicCommissions',
                total: true,
                displayGrid: true,
                disableEditor: true,
                disableSort: true
            },
            {
                id: 'paymentUuid',
                label: 'paymentUuid',
                alignRight: false,
                cell: 'ServerSearch',
                searchFields: ['uuid'],
                outputField: 'uuid',
                searchController: 'paymentInstances',
                object: 'payment',
                show: 'uuid',
                displayGrid: true,
                displayAdd: true,
                disableEditor: true
            },
            {
                id: 'chargebacksDocuments',
                label: 'chargebackDocuments',
                alignRight: false,
                cell: 'Text',
                displayGrid: true,
                displayAdd: false,
                disableEditor: true,
                customData: true,
                disableSort: true
            },
            {
                id: 'chargebacksComments',
                label: 'chargebackComments',
                alignRight: false,
                cell: 'Text',
                displayGrid: true,
                displayAdd: false,
                disableEditor: true,
                customData: true,
                disableSort: true
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName',
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated',
            },
        ];

        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head,

            chargebackId: null,

            currentChargebackDocuments: [],
            currentChargebackComments: [],
            chargebacksDocumentsOpen: false,
            chargebacksCommentsOpen: false,

            openDialogConfirm: false
        };
    }

    customLogicOnMount = async () => {
        const documentsRes = await this.fetchChargebacksDocuments();
        const commentsRes = await this.fetchChargebacksComments();
        this.chargebacksDocuments = documentsRes.data;
        this.chargebacksComments = commentsRes.data;
    };

    fetchChargebacksDocuments = async () => {
        return await this.props.context
            .getState()
            .server.publicChargebackDocuments.getAll();
    };
    fetchChargebacksComments = async () => {
        return await this.props.context
            .getState()
            .server.publicChargebackComments.getAll();
    };

    openChargebacksDocuments = () => {
        const chargebackId = this.state.menuClickItemId;
        const currentChargebackDocuments = this.chargebacksDocuments?.filter(
            (document) => document.chargeback?.id === chargebackId
        );
        this.setState({
            chargebacksDocumentsOpen: true,
            currentChargebackDocuments,
            chargebackId
        });
        this.handleCloseMenu();
    };

    openChargebacksComments = () => {
        const chargebackId = this.state.menuClickItemId;
        const currentChargebackComments = this.chargebacksComments?.filter(
            (comment) => comment.chargeback?.id === chargebackId
        );
        this.setState({
            chargebacksCommentsOpen: true,
            currentChargebackComments,
            chargebackId
        });
        this.handleCloseMenu();
    };

    closeChargebacksDocuments = async () => {
        this.setState({ chargebacksDocumentsOpen: false, chargebackId: null });
    };

    closeChargebacksComments = async () => {
        this.setState({ chargebacksCommentsOpen: false, chargebackId: null });
    };

    setChargebackDocuments = async () => {
        const id = this.state.chargebackId;
        const res = await this.fetchChargebacksDocuments();
        this.chargebacksDocuments = res.data;
        const currentChargebackDocuments = res.data.filter(
            (document) => document.chargeback?.id === id
        );
        this.setState({
            currentChargebackDocuments
        });
    };

    setChargebackComments = async () => {
        const id = this.state.chargebackId;
        const res = await this.fetchChargebacksComments();
        this.chargebacksComments = res.data;
        const currentChargebackComments = res.data.filter(
            (comment) => comment.chargeback?.id === id
        );
        this.setState({ currentChargebackComments });
    };

    handleUpdateStatus = async () => {
        const { status } = this.state;
        const id = this.state.chargebackId;

        await this.Server.updateStatus(id, status);
        this.setState({ openDialogConfirm: false, status: '', chargebackId: null });
        await this.retrieveData();
    };
    handleCancelStatusConfirm = () => {
        this.setState({ openDialogConfirm: false, status: '', chargebackId: null });
    };
    handleUpdateStatusConfirm = (status) => {
        const alertText = i18n.t(`common.${status}AlertText`);
        const alertTitle = i18n.t(`common.${status}AlertTitle`);
        const chargebackId = this.state.menuClickItemId;
        this.setState({
            openDialogConfirm: true,
            status,
            alertText,
            alertTitle,
            chargebackId
        });
        this.handleCloseMenu();
    };

    renderCustomMenuItems() {
        const chargebackId = this.state.menuClickItemId;
        const currentChargebackCommentsLength =
            this.chargebacksComments?.filter(
                (comment) =>
                    comment.chargeback?.id === chargebackId
            ).length || 0;
        const currentChargebackDocumentsLength =
            this.chargebacksDocuments?.filter(
                (document) =>
                    document.chargeback?.id === chargebackId
            ).length || 0;

        const value = this.List.find(
            (item) => item.id === chargebackId
        )?.state;
        const isAllowedChangeStatusAction =
            this.allowedAction('chargeback-approve-reject') &&
            value &&
            value !== chargebackStatuses.accepted &&
            value !== chargebackStatuses.rejected;

        return [
            isAllowedChangeStatusAction && (
                <MenuItem
                    key="check"
                    onClick={() =>
                        this.handleUpdateStatusConfirm(
                            chargebackStatuses.accepted
                        )
                    }
                >
                    <Iconify icon={'ic:baseline-check'} sx={{ mr: 2 }} />
                    {i18n.t('buttons.approve')}
                </MenuItem>
            ),
            isAllowedChangeStatusAction && (
                <MenuItem
                    key="reject"
                    onClick={() =>
                        this.handleUpdateStatusConfirm(
                            chargebackStatuses.rejected
                        )
                    }
                >
                    <Iconify icon={'eva:close-fill'} sx={{ mr: 2 }} />
                    {i18n.t('buttons.reject')}
                </MenuItem>
            ),
            <MenuItem
                key="chargebacksDocuments"
                onClick={() => this.openChargebacksDocuments()}
            >
                <TextSnippetIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.chargebacksDocuments')}
                <Chip sx={{ ml: 1 }} label={currentChargebackDocumentsLength} />
            </MenuItem>,
            <MenuItem
                key="chargebacksComments"
                onClick={() => this.openChargebacksComments()}
            >
                <CommentIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.chargebacksComments')}
                <Chip sx={{ ml: 1 }} label={currentChargebackCommentsLength} />
            </MenuItem>
        ];
    }

    renderCustom() {
        const chargebackId = this.state.chargebackId;

        return (
            <div>
                <DocumentsDialog
                    dialogOpen={this.state.chargebacksDocumentsOpen}
                    dialogData={this.state.currentChargebackDocuments}
                    id={chargebackId}
                    type="chargeback"
                    onCancel={() => this.closeChargebacksDocuments()}
                    fetchData={() => this.setChargebackDocuments()}
                    context={this.props.context}
                />
                <CommentsDialog
                    dialogOpen={this.state.chargebacksCommentsOpen}
                    dialogData={this.state.currentChargebackComments}
                    id={chargebackId}
                    type="chargeback"
                    controller="publicChargebackComments"
                    onCancel={() => this.closeChargebacksComments()}
                    fetchData={() => this.setChargebackComments()}
                />
                <ConfirmDialog
                    dialogOpen={this.state.openDialogConfirm}
                    alertText={this.state.alertText}
                    alertTitle={this.state.alertTitle}
                    onCancel={this.handleCancelStatusConfirm}
                    onConfirm={this.handleUpdateStatus}
                />
            </div>
        );
    }

    renderCustomGridCell(Component, row, field) {
        const dates = {
            chargebacksDocuments: this.chargebacksDocuments,
            chargebacksComments: this.chargebacksComments
        };
        const data = dates[field.id] || [];

        const currentData = data.filter(
            (item) => item.chargeback?.id === row.id
        );
        const value = currentData ? currentData.length : 0;

        return (
            <Component
                key={field.label}
                id={row.id}
                value={value}
                field={field}
                row={row}
                handleChange={this.handleChangeCell}
            />
        );
    }
}
